export const getModalContent = (item, index) => {
  return item?.cta?.[index];
};
